<template>
    <div>
        <div class="main-display-width border-box" style="display:flex;padding:3px;justify-content: center;flex-wrap: wrap;">
            <contact-form ref="contactForm"
                          style="width:100%;max-width: 600px;min-width:380px;margin:3px;flex: 1 1 380px;"></contact-form>
            <google-maps ref="map" style="width:100%;max-width: 600px;min-width:380px;margin: 3px;flex: 1 1 380px;"></google-maps>

        </div>
        <contact-card></contact-card>
    </div>
</template>

<script>
	import ContactCard from "@/components/ContactCard";
	import ContactForm from "@/components/ContactForm";
	import GoogleMaps from "@/components/GoogleMaps";

	export default {
		name: "Contact",
		props: {
			baseURL: String
		},
		data() {
			return {
				formHeight: 0
			}
		},
		components: {GoogleMaps, ContactCard, ContactForm},
		component: {
			ContactForm,
			ContactCard,
			GoogleMaps
		},
		computed: {
			small() {
				return this.$mq === 'sm';
			}
		},
		mounted() {
			window.addEventListener("resize", this.winResize);
			this.winResize();
		},
		destroyed() {
			window.removeEventListener("resize", this.winResize);
		},
		methods: {
			winResize() {
				this.formHeight=this.$refs.contactForm.$el.clientHeight;
				this.$refs.map.$el.style.height=this.formHeight+'px';
				console.log(this.$refs.contactForm.$el.clientHeight)
				// your code for handling resize...
			}
		}
	}
</script>

<style scoped>
</style>